import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  startPolling,
  stopPolling,
} from '../redux/actions/reportPollingActions';

// This component doesn't render anything, it just manages the polling
const ReportPdfStatusPoller = ({ startPolling, stopPolling }) => {
  useEffect(() => {
    // Start polling when component mounts
    startPolling(5000); // Poll every 5 seconds

    // Stop polling when component unmounts
    return () => {
      stopPolling();
    };
  }, [startPolling, stopPolling]);

  // This component doesn't render anything
  return null;
};

ReportPdfStatusPoller.propTypes = {
  startPolling: PropTypes.func.isRequired,
  stopPolling: PropTypes.func.isRequired,
};

export default connect(null, { startPolling, stopPolling })(
  ReportPdfStatusPoller
);
